import * as React from 'react';
import { Checkbox, Dropdown } from 'semantic-ui-react';

interface State {
  selected: number;
}

interface Props {
  refresh?: number;
  inline?: boolean;
  onChange?: (interval: number| undefined, enabled: boolean) => void;
}

export default class UpdateList extends React.Component<Props, State> {
    public static defaultProps: Partial<Props> = {
        inline: false
    };

    static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        if (nextProps.refresh)
            return { selected: nextProps.refresh };
        else return null;
    }

    constructor(props: Props) {
        super(props);
        this.state = {
            selected: 30000
        };
    }

    /*componentWillReceiveProps(nextProps: Props) {
        if (this.props.refresh !== nextProps.refresh) {
            if (nextProps.refresh)
                this.setState({ selected: nextProps.refresh });
        }
    }*/

    render() {
        const { refresh, onChange, inline } = this.props;
        const updateOptions = [ {'value':  5000, 'text': '5 Sec'  }, {'value': 10000, 'text': '10 Sec' },
                                {'value': 20000, 'text': '20 Sec' }, {'value': 30000, 'text': '30 Sec' },
                                {'value': 40000, 'text': '40 Sec' }, {'value': 50000, 'text': '50 Sec' },
                                {'value': 60000, 'text': '1 Min'  }, {'value': 120000, 'text': '2 Min' },
                                {'value': 180000, 'text': '3 Min' }, {'value': 240000, 'text': '4 Min' },
                                {'value': 300000, 'text': '5 Min' }, {'value': 600000, 'text': '10 Min'},
                                {'value': 900000, 'text': '15 Min'}];

        return (
            <div className="update-every">
                <Checkbox
                    className="update-checkbox"
                    label="Update Every &nbsp;"
                    checked={refresh !== undefined}
                    onChange={(event: any, data: any) => onChange && onChange((this.state && data.checked) ? this.state.selected : undefined, data.checked)}
                />
                <Dropdown
                    inline={inline}
                    selection={!inline}
                    className={inline ? undefined : 'update-Dropdown'}
                    options={updateOptions}
                    value={this.state && this.state.selected || 30000}
                    onChange={(event: any, data: any) =>
                        this.setState({selected: data.value},
                                      () => onChange && onChange(data.value, refresh !== undefined)
                        )}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/updateList.tsx